import { newToolFilterOAuthMcp } from "../oauth.ts";

export const parallelSearchMcpResolver = newToolFilterOAuthMcp({
  iconUrl: "https://parallel.ai/apple-icon.png",
  url: "https://search-mcp.parallel.ai/mcp",
  label: "Parallel Search",
});
